module.exports = __webpack_public_path__ + "c06784fdfa630e685075584bafe741e3.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/trailer-teaser-460.mp4
// module id = 657
// module chunks = 0